// @flow
import React, { Component } from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';

import { FullButton, GradientPage, Icon } from '../../../components/common';
import { PageTitle } from '../../../components/signUp';
import DoItLater from '../DoItLater';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

type PropsType = {
  canSkipPayment: boolean,
  isLoading: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
};

export default class CardRegistrationIssue extends Component<PropsType> {
  styles = getStyles();

  goBack = () => this.props.navigation.goBack();

  render() {
    const styles = this.styles;
    return (
      <GradientPage iosEdges={['top','bottom']}>
        <PageTitle title={I18n.t('SignUp.Payment.error')} style={styles.title} />
        <View style={styles.container}>
          {theme.creditCardImage ? (
            <Image style={styles.image} source={theme.creditCardImage} />
          ) : (
            <Icon name="credit-card" size={129} color={theme.signUpTextColor} style={styles.creditCard} />
          )}
          <View>
            <Text style={[styles.message, styles.callBankText]}>{I18n.t('SignUp.Payment.callBankText')}</Text>
            <Text style={[styles.message, styles.callBankText]}>- {I18n.t('SignUp.Payment.eCommerce')}</Text>
            <Text style={[styles.message, styles.callBankText]}>- {I18n.t('SignUp.Payment.3DSecure')}</Text>
          </View>
          {this.props.isLoading ? (
            <ActivityIndicator color={theme.primaryColor} />
          ) : (
            <View>
              <FullButton text={I18n.t('SignUp.Payment.callToActionText')} onPress={this.goBack} />
              {this.props.canSkipPayment && <DoItLater style={styles.doItLater} />}
            </View>
          )}
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    title: {
      marginHorizontal: 29,
      marginTop: 20,
    },
    container: {
      flex: 1,
      justifyContent: 'space-around',
      marginHorizontal: 29,
    },
    message: {
      textAlign: 'center',
      color: theme.signUpDarkTextColor,
    },
    callBankText: {
      fontSize: 15,
    },
    creditCard: {
      backgroundColor: 'transparent',
      alignSelf: 'center',
    },
    image: {
      width: 170,
      height: 129,
      alignSelf: 'center',
    },
    doItLater: {
      marginTop: 10,
    },
  });
